<template>
    <div class="button_add mb-4">
        <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_time()">
            <span class="fal  fa-eject mr-1"></span>
                {{__t('ADD')}}
        </button>

        <div class="time_info">
            <ul class="list-style-none">
                <li class="mt-2 list-style-none" v-for="(item,idx) in this.times_work">
                    <div class="row row-no-padding">
                        <div class="col-5">
                            <b-form-timepicker :key="'t_'.idx" v-model="item.start" class="mb-2"></b-form-timepicker>
                        </div>
                        <div class="col-5">
                            <b-form-timepicker :key="'e_'.idx"  v-model="item.end"  class="mb-2"></b-form-timepicker>
                        </div>
                        <div class="col-2">
                            <button type="button" class="btn btn-outline-danger" v-on:click="remove(idx)">
                                {{__t('REMOVE')}}
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        name: "day",
        props : {
            cur_idx : {
                type : Number,
                required : true
            },
            times : {
                type : Array,
            }
        },

        data() {
            return {
               times_work : []
            }
        },

        created () {
            this.times_work = this.times;
        },

        methods  :{
            add_time() {
                this.times.push({
                    'start' : "08:00:00",
                    'end' : "23:50:00",
                })

            },

            remove(idx) {
                this.times_work.splice(idx,1);
            }

        }
    }
</script>

<style scoped>
    .list-style-none {
        padding-left: 0;
        margin-left: 0;
        list-style: none;
    }
</style>
